import React, { FC } from 'react';
import LargeAreaChartLoader from 'components/Loaders/LargeAreaChart';
import SmallAreaChart from 'components/Loaders/SmallAreaChart';
import IndicatorLoader from 'components/Loaders/Indicator';
import PieChartLoader from 'components/Loaders/PieChart';
import {
  Container,
  Indicators,
  TwoColumns,
  TwoRows,
  Section,
  SectionTitle,
  Indicator,
  ChartWrapper,
  PieChart,
  AreaChart,
  DatesSelector,
  Header,
  DateCaption,
  RevenueSection,
} from './styles';
import useConnect from './connect';
import { Props } from './types';

const Sales: FC<Props> = ({ brandId }) => {
  const {
    sales,
    isLoading,
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
  } = useConnect({
    brandId,
  });

  return (
    <Container>
      <Header>
        <DateCaption>Date range</DateCaption>
        <DatesSelector
          hoverRange={hoverRange}
          selectedDays={selectedDays}
          handleDayChange={handleDayChange}
          handleDayEnter={handleDayEnter}
          handleDayLeave={handleDayLeave}
          handleWeekClick={handleWeekClick}
          disableFutureWeeksPick
        />
      </Header>

      <Indicators>
        {!sales || isLoading ? (
          <>
            <IndicatorLoader />
            <IndicatorLoader />
            <IndicatorLoader />
            <IndicatorLoader />
          </>
        ) : (
          <>
            <Indicator
              title="Sales"
              amount={`${sales.totalSales.value}`}
              trend={sales.totalSales.change < 0 ? 'DOWN' : 'UP'}
              percentage={sales.totalSales.change}
            />
            <Indicator
              title="Orders"
              amount={`${sales.orders.value}`}
              trend={sales.orders.change < 0 ? 'DOWN' : 'UP'}
              percentage={sales.orders.change}
            />
            <Indicator
              title="Average orders / Day"
              amount={`${sales.ordersPerDay.value}`}
              trend={sales.ordersPerDay.change < 0 ? 'DOWN' : 'UP'}
              percentage={sales.ordersPerDay.change}
            />
            <Indicator
              title="Average orders value"
              amount={`${sales.aov.value}`}
              trend={sales.aov.change < 0 ? 'DOWN' : 'UP'}
              percentage={sales.aov.change}
            />
          </>
        )}
      </Indicators>

      <TwoColumns>
        <RevenueSection>
          <SectionTitle>Revenue</SectionTitle>
          {!sales || isLoading ? (
            <LargeAreaChartLoader />
          ) : (
            <AreaChart
              data={sales.revenue}
              variant="green"
              hideAxisX
              isMoney
              yAxisTooltipName="Revenue"
            />
          )}
        </RevenueSection>

        <TwoRows>
          <Section>
            <SectionTitle>Number of orders</SectionTitle>
            {!sales || isLoading ? (
              <SmallAreaChart />
            ) : (
              <AreaChart
                data={sales.dailyOrders}
                variant="red"
                hideAxisX
                yAxisTooltipName="Orders"
              />
            )}
          </Section>

          <Section>
            <SectionTitle>Sales</SectionTitle>
            {!sales || isLoading ? (
              <PieChartLoader />
            ) : (
              <ChartWrapper>
                <PieChart data={sales.integrationRatings} />
              </ChartWrapper>
            )}
          </Section>
        </TwoRows>
      </TwoColumns>
    </Container>
  );
};

export default Sales;
